import { LegalRight } from 'helpers';

import { BrandAccessRight } from '../../../../retailer-platform/brands/types';

export enum TrackingEvents {
    NEWSFEED_CONTENT_CLICKED = 'newsfeed_click',
    BRAND_SELECTED = 'chose_brand',
    FILTER_INTERACTION = 'filter_interaction',
    BRAND_ACCESS_CLICK_CONNECT = 'click_connect',
    BRAND_ACCESS_REQUEST_CONFIRMED = 'request_confirmed',
    RETAILER_RIGHTS_UPDATED = 'retailer_rights_updated',
    SEARCH = 'search',
    BUTTON_CLICK = 'button_click',
    SELECT_ITEM = 'select_item',
    ADD_TO_CART = 'add_to_cart',
    EDIT_CART = '[Re] shopping cart contents changed',
    PURCHASE = 'purchase',
    REMOVE_FROM_CART = 'remove_from_cart',
    VIEW_CART = 'view_cart',
    VIEW_ITEM = 'view_item',
    VIEW_ITEM_LIST = 'view_item_list',
    PROFILE_OPENED = 'profile_opened',
    SHOPPING_CART_TAB_SWITCH = '[Re] shopping cart tab switched',
    EDIT_STORES_DISPLAY = '[Re] edit stores modal displayed',
    EDIT_STORES_DROPDOWN_CLICK = '[Re] edit stores dropdown clicked',
    MULTI_STORE_ORDER_PLACE = '[Re] multi store order placed successfully',
    MULTI_STORE_USER_WITH_SINGLE_STORE_ORDER_PLACE = '[Re] multi store order for a single store placed successfully'
}

export enum PayloadProperties {
    PAGE_TYPE = 'page_type',
    CLICK_URL = 'click_url',
    POST_NAME = 'post_name',
    PROMOTED_BRAND_NAME = 'promoted_brand_name',
    POSITION_FEED = 'position_feed',
    BRAND = 'brand',
    RETAILER = 'retailer',
    CONTENT_TYPE = 'content_type',
    FILTER_SEASON = 'filter_season',
    FILTER_CHANNELS = 'filter_channels',
    FILTER_EXPIRY_DATE = 'filter_expiry_date',
    FILTER_SEARCH_INPUT = 'filter_search_input',
    FILTER_TYPE = 'filter_type',
    FILTER_TARGET_GROUP = 'filter_target_group',
    FILTER_BRAND = 'filter_brand',
    FILTER_COLOR = 'filter_color',
    FILTER_SIZE = 'filter_size',
    FILTER_GENERAL_SIZES = 'filter_general_sizes',
    FILTER_LENGTHS = 'filter_lengths',
    FILTER_WIDTHS = 'filter_widths',
    FILTER_FIT = 'filter_fit',
    FILTER_DISCOUNT = 'filter_discount',
    FILTER_MIN_STOCK = 'filter_min_stock',
    FILTER_RETAILER = 'filter_retailer',
    FILTER_ORDER_DATE = 'filter_order_date',
    FILTER_ORDER_TYPE = 'filter_order_type',
    FILTER_CATALOG = 'filter_catalogs',
    FILTER_LAST_ORDERED_ARTICLES = 'filter_last_ordered_articles',
    BRAND_CONNECT_WITH_NOTE = 'with_note',
    NOTE = 'note',
    ACCESS_TYPE_REQUESTED = 'access_type',
    RETAILER_TERMS = 'retailer_terms',
    BRAND_TERMS = 'brand_terms',
    ELEMENT_NAME = 'element_name',
    USER_ROLE = 'user_role',
    BRAND_PLAN = 'brand_type',
    SEARCH_TERM = 'search_term',
    SEARCH_RESULTS = 'search_results',
    ECOMMERCE = 'ecommerce',
    ITEM_LIST_ID = 'item_list_id',
    ITEM_LIST_NAME = 'item_list_name',
    ITEMS = 'items',
    VALUE = 'value',
    FEATURED_BRAND = 'featured_brand',
    FEATURED_BRAND_SOURCE = 'featured_brand_source',
    TAB_NAME = 'tab_name',
    RETAILER_ID = 'retailer_id'
}

export interface TrackingEventsWithPayloads {
    [TrackingEvents.NEWSFEED_CONTENT_CLICKED]: {
        [PayloadProperties.POST_NAME]: string;
        [PayloadProperties.PROMOTED_BRAND_NAME]: string;
        [PayloadProperties.POSITION_FEED]: string;
    };
    [TrackingEvents.BRAND_SELECTED]:
        | {
              [PayloadProperties.PAGE_TYPE]: 'content';
              [PayloadProperties.BRAND]: string;
              [PayloadProperties.CONTENT_TYPE]: 'product';
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'content';
              [PayloadProperties.BRAND]: string;
              [PayloadProperties.CONTENT_TYPE]: 'marketing';
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'preorder';
              [PayloadProperties.BRAND]: string;
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'reorder';
              [PayloadProperties.BRAND]: string[];
          };
    [TrackingEvents.FILTER_INTERACTION]:
        | {
              [PayloadProperties.PAGE_TYPE]: 'marketing_material';
              [PayloadProperties.FILTER_SEASON]?: string[];
              [PayloadProperties.FILTER_CHANNELS]?: string[];
              [PayloadProperties.FILTER_EXPIRY_DATE]?: string[];
              [PayloadProperties.FILTER_SEARCH_INPUT]?: string[];
              [PayloadProperties.FILTER_TYPE]?: string[];
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'product_data';
              [PayloadProperties.FILTER_SEASON]?: string[];
              [PayloadProperties.FILTER_TARGET_GROUP]?: string[];
              [PayloadProperties.FILTER_LAST_ORDERED_ARTICLES]?: boolean;
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'reorder';
              [PayloadProperties.FILTER_SEASON]: string[];
              [PayloadProperties.FILTER_COLOR]: string[];
              [PayloadProperties.FILTER_SIZE]: string[];
              [PayloadProperties.FILTER_GENERAL_SIZES]: string[];
              [PayloadProperties.FILTER_WIDTHS]: string[];
              [PayloadProperties.FILTER_LENGTHS]: string[];
              [PayloadProperties.FILTER_TARGET_GROUP]: string[];
              [PayloadProperties.FILTER_DISCOUNT]: string[];
              [PayloadProperties.FILTER_MIN_STOCK]: string[];
              [PayloadProperties.FILTER_FIT]?: string[];
              [PayloadProperties.FILTER_CATALOG]?: string[];
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'preorder';
              [PayloadProperties.FILTER_COLOR]: string[];
              [PayloadProperties.FILTER_SIZE]: string[];
              [PayloadProperties.FILTER_TARGET_GROUP]: string[];
              [PayloadProperties.FILTER_SEASON]: string[];
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'order_history';
              [PayloadProperties.FILTER_BRAND]: string[];
              [PayloadProperties.FILTER_RETAILER]: string[];
              [PayloadProperties.FILTER_ORDER_TYPE]: string[];
              [PayloadProperties.FILTER_ORDER_DATE]: string;
          };
    [TrackingEvents.BRAND_ACCESS_CLICK_CONNECT]: {
        [PayloadProperties.BRAND_CONNECT_WITH_NOTE]: boolean;
        [PayloadProperties.ACCESS_TYPE_REQUESTED]: BrandAccessRight[];
        [PayloadProperties.BRAND]: string;
        [PayloadProperties.PAGE_TYPE]: string;
        [PayloadProperties.FEATURED_BRAND]: number | boolean;
        [PayloadProperties.FEATURED_BRAND_SOURCE]: string;
    };
    [TrackingEvents.BRAND_ACCESS_REQUEST_CONFIRMED]: {
        [PayloadProperties.ACCESS_TYPE_REQUESTED]: LegalRight[];
        [PayloadProperties.BRAND]: string;
    };
    [TrackingEvents.RETAILER_RIGHTS_UPDATED]: {
        [PayloadProperties.ACCESS_TYPE_REQUESTED]: LegalRight[];
        [PayloadProperties.BRAND]: string;
        [PayloadProperties.RETAILER]: string;
        [PayloadProperties.PAGE_TYPE]: string;
        [PayloadProperties.RETAILER_TERMS]?: boolean;
    };
    [TrackingEvents.SEARCH]:
        | {
              [PayloadProperties.PAGE_TYPE]: 'brand_access';
              [PayloadProperties.FILTER_BRAND]: string;
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'reorder' | 'preorder';
              [PayloadProperties.SEARCH_TERM]: string;
              [PayloadProperties.SEARCH_RESULTS]: number;
          };
    [TrackingEvents.BUTTON_CLICK]:
        | {
              [PayloadProperties.PAGE_TYPE]: 'team';
              [PayloadProperties.ELEMENT_NAME]: 'invite_team';
              [PayloadProperties.USER_ROLE]: string;
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'stores';
              [PayloadProperties.ELEMENT_NAME]: 'store_creation';
          }
        | {
              [PayloadProperties.PAGE_TYPE]: 'content';
              [PayloadProperties.ELEMENT_NAME]: 'marketing_material_upload';
          };
    [TrackingEvents.SELECT_ITEM]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEM_LIST_ID]: 'related_products';
            [PayloadProperties.ITEM_LIST_NAME]: 'Related products';
            [PayloadProperties.ITEMS]: Item[];
        };
    };
    [TrackingEvents.ADD_TO_CART]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
        };
    };
    [TrackingEvents.EDIT_CART]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
            [PayloadProperties.VALUE]: number;
        };
    };
    [TrackingEvents.PURCHASE]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
            [PayloadProperties.VALUE]: number;
        };
    };
    [TrackingEvents.REMOVE_FROM_CART]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
            [PayloadProperties.VALUE]: number;
        };
    };
    [TrackingEvents.VIEW_CART]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
            [PayloadProperties.VALUE]: number;
        };
    };
    [TrackingEvents.VIEW_ITEM]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
            [PayloadProperties.VALUE]: number;
        };
    };
    [TrackingEvents.VIEW_ITEM_LIST]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
            [PayloadProperties.VALUE]: number;
        };
    };
    [TrackingEvents.MULTI_STORE_ORDER_PLACE]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
            [PayloadProperties.VALUE]: number;
        };
    };
    [TrackingEvents.MULTI_STORE_USER_WITH_SINGLE_STORE_ORDER_PLACE]: {
        [PayloadProperties.ECOMMERCE]: {
            [PayloadProperties.ITEMS]: Item[];
            [PayloadProperties.VALUE]: number;
        };
    };

    [TrackingEvents.PROFILE_OPENED]: {
        [PayloadProperties.BRAND]: string;
        [PayloadProperties.PAGE_TYPE]: string;
        [PayloadProperties.ACCESS_TYPE_REQUESTED]: string[];
        [PayloadProperties.FEATURED_BRAND]: number | boolean;
        [PayloadProperties.FEATURED_BRAND_SOURCE]: string;
    };
    [TrackingEvents.SHOPPING_CART_TAB_SWITCH]: {
        [PayloadProperties.PAGE_TYPE]: string;
        [PayloadProperties.TAB_NAME]: string;
    };
    [TrackingEvents.EDIT_STORES_DISPLAY]: {
        [PayloadProperties.PAGE_TYPE]: string;
        [PayloadProperties.RETAILER_ID]: string;
    };
    [TrackingEvents.EDIT_STORES_DROPDOWN_CLICK]: {
        [PayloadProperties.PAGE_TYPE]: 'stores';
        [PayloadProperties.ELEMENT_NAME]: 'store_creation';
    };
}

interface Item {
    item_id: string;
    item_name: string;
    currency: string;
    discount: number;
    item_brand: string;
    item_list_id: string;
    item_list_name: string;
    item_variant: string;
    price: number;
    affiliation?: string;
}
